<template>
    <div class="IMG">
        <img src="../img/6.jpeg" style="background-size: cover;">
        <!--<div class="dlb" >-->
            <div class="login_box">
                <el-form ref="form" :model="form" label-width="50px">
                    <el-form-item style="font-size: 16px;color:#FFFFFF">杭州电子科技大学 圣光机联合学院</el-form-item>
                    <el-form-item label="账号" style="margin-left: -30px;width: 250px;">
                        <el-input placeholder="请输入账号" v-model="form.usename"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" style="margin-left: 250px;margin-top:-65px;width: 250px">
                        <el-input placeholder="请输入密码" v-model="form.password" show-password></el-input>
                    </el-form-item>
                </el-form>>
                <el-row style="margin-top: 5px;margin-left: 70px">
                    <!--<el-button>注册</el-button>-->
                    <el-button  @click = "handle" style="background-color: transparent;border: none;outline: none;margin-top:10px;margin-right: -500px"><i class="el-icon-right" style="font-size: 30px"></i></el-button>
                </el-row>
            </div>
        </div>
    <!--</div>-->
</template>


<script lang="ts" setup>
    export default {
        methods:{
            handle (){
                //  路径在router目录下index.js中定义的path属性值
                this.$router.push('/login');
            }
        },
        data() {
            return {
                form: {
                    usename:'admin',
                    password:'1',
                }
            }
        }
    }

</script>

<style scss>
    /*引入样式*/
    @import '../css/login.css';

</style>